export default __webpack_public_path__ + "static/media/week_image.fa497d94.png";